import * as d3 from 'd3';
import { prepareRSI } from '../prepIndicator/prepareRSI';

export const drawRSI = (svg, data, xScale, yScale, value, color = '#c084fc') => {
    try {
        const rsiData = prepareRSI(data, value);

        if (!rsiData || !rsiData.rsi || rsiData.rsi.length === 0) {
            console.warn('Incomplete or empty RSI data:', rsiData);
            return;
        }

        const validRSIData = rsiData.rsi.filter(point =>
            point.y !== null &&
            !isNaN(point.y) &&
            point.y >= yScale.domain()[0] &&
            point.y <= yScale.domain()[1]
        );

        if (validRSIData.length === 0) {
            console.warn("No valid RSI data points to plot");
            return;
        }

        // Reference lines (30/70) are drawn once by the caller
        // (D3SubCharts.js's addReferenceLines) -- not duplicated here.
        const rsiLine = d3.line()
            .x(d => xScale(d.x))
            .y(d => yScale(d.y))
            .curve(d3.curveMonotoneX);

        svg.append("path")
            .datum(validRSIData)
            .attr("fill", "none")
            .attr("stroke", color)
            .attr("stroke-width", 1.5)
            .attr("d", rsiLine);
    } catch (error) {
        console.warn('Error rendering RSI:', error);
    }
};